export function BrowserEngineDetect() {
    let htmlElement = document.documentElement;

    if (typeof htmlElement === 'undefined') {
        return false;
    }

    htmlElement.className += (typeof htmlElement.style.msTransition !== 'undefined') ? ' is-ms ' : ' not-ms ';
    htmlElement.className += (typeof htmlElement.style.MozTransition !== 'undefined') ? ' is-moz ' : ' not-moz ';
    htmlElement.className += (typeof htmlElement.style.webkitLineClamp !== 'undefined') ? ' is-webkit ' : ' not-webkit ';
}